import * as R from 'ramda';

export const scaleOptions = R.range(1,11);